var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.224,
    height: 9.227,
    viewBox: "0 0 16.224 9.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down_arrow",
    "data-name": "down arrow",
    d: "M2.639,14.949a1.029,1.029,0,0,0-.21.307.925.925,0,0,0-.076.38.938.938,0,0,0,.129.486.976.976,0,0,0,.347.348.949.949,0,0,0,.494.129.9.9,0,0,0,.69-.289l6.928-7.081h-.95l6.917,7.081a.926.926,0,0,0,.7.289.949.949,0,0,0,.494-.129.976.976,0,0,0,.347-.348.938.938,0,0,0,.129-.486.918.918,0,0,0-.286-.686L11.2,7.7a.952.952,0,0,0-.334-.246.987.987,0,0,0-.4-.081,1,1,0,0,0-.738.326Z",
    transform: "translate(18.577 16.599) rotate(180)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.7b5c1007c509fa71e5c48fb6cfc1b94a.svg";
export { ForwardRef as ReactComponent };